

const getTextOfSelector = (id, isSortType = true) => {
    const value = '' + id
    if (isSortType) {
        switch (value) {
            case '0':
                return "بیشترین دانلود"
            case '1':
                return "کمترین دانلود"
            case '2':
                return "بیشترین خرید"
            case '3':
                return "کمترین خرید"

            default:
                return value
        }
    } else {
        switch (value) {
            case '0':
                return "هفته اخیر"
            case '1':
                return "ماه اخیر"
            case '2':
                return "3 ماه گذشته"

            default:
                return value
        }
    }
}

const TitleBarReportPage = ({ filters = { empty: '' }, sort = { sortType: '0', dateType: '1' } }) => {

    return (<>
        <div className="reportTitleBar">
            {Object.values(filters)?.filter(e => e !== "").length > 0 &&
                <div className="rh">
                    <b>لیست عناوین:</b>
                    <ul>
                        {filters?.filterUserId && <li>{filters.filterUserId.name}</li>}
                        {filters?.publishDate && <li>سال {filters.publishDate.name}</li>}
                        {filters?.ages && <li>رده سنی {filters.ages.name}</li>}
                        {filters?.primarySubjectCategoryId && <li>دسته {filters.primarySubjectCategoryId.name}</li>}
                        {filters?.secondarySubjectCategoryId && <li>دسته ثانویه {filters.primarySubjectCategoryId.name} - {filters.secondarySubjectCategoryId.name}</li>}
                    </ul>
                </div>}

            {Object.values(sort)?.filter(e => e !== "").length > 0 &&
                <div className="rh">
                    <b>براساس</b>
                    <ul>
                        {(sort?.sortType)?.toString() && <li>{getTextOfSelector(sort.sortType, true)}</li>}
                    </ul>
                    <b style={{ marginRight: 6 }}>در </b>
                    <ul>
                        {(sort?.dateType)?.toString() && <li>{getTextOfSelector(sort.dateType, false)}</li>}
                        {sort?.regDateFrom && <li>{sort.regDateFrom.replaceAll("-", "/")} {sort?.regDateTo && <span dir="ltr">تا {sort.regDateTo.replaceAll("-", "/")}</span>}</li>}
                    </ul>
                </div>}

        </div>
    </>);
}

export default TitleBarReportPage;